import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";


export enum ImageSize{
  smallest = 100,
  small = 200,
  medium = 500,
  large = 1000,
  largest = 2000
}

export enum CropMethod{
  contain = 'contain',
  crop = 'crop'
}
@Injectable({
  providedIn: 'root',
})
export class ImageService {

  public urlForFileNameAndQuality(filename: string,size: ImageSize,cropMethod: CropMethod = CropMethod.contain): string{
    let sizeKey: String;
    switch (size) {
      case ImageSize.smallest:
        sizeKey = "smallest";
        break;
      case ImageSize.small:
          sizeKey = "small";
        break;
      case ImageSize.medium:
          sizeKey = "medium";
        break;
      case ImageSize.large:
        sizeKey = "large";
        break;
      case ImageSize.largest:
          sizeKey = "largest";
        break;
    }
    return [environment.cmsMediaURL,filename+"?key="+sizeKey+cropMethod].join("/");
  }

  constructor() {
  }


}
